import { render, staticRenderFns } from "./TheListCard.vue?vue&type=template&id=36c7b0aa&"
import script from "./TheListCard.vue?vue&type=script&lang=js&"
export * from "./TheListCard.vue?vue&type=script&lang=js&"
import style0 from "./TheListCard.vue?vue&type=style&index=0&id=36c7b0aa&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports